import { render, staticRenderFns } from "./EncardGameSnowy.vue?vue&type=template&id=26ef93c9&scoped=true&"
import script from "./EncardGameSnowy.vue?vue&type=script&lang=js&"
export * from "./EncardGameSnowy.vue?vue&type=script&lang=js&"
import style0 from "./EncardGameSnowy.vue?vue&type=style&index=0&id=26ef93c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ef93c9",
  null
  
)

export default component.exports